import _ from "lodash";

const token = "?token=";
const tick = "&tick=";

async function renewSingleUseTokenForPresignedUrl(preSignedUrl, _this) {
  const mediaId = preSignedUrl && preSignedUrl.split(token)[1] + "";

  if (!mediaId) {
    _this.$toastr.error("Error while getting presigned URL.");
    return;
  }

  await _this.$api.printAgreementDocument({ mediaId });

  return new Promise((resolve, reject) => {
    resolve(`${preSignedUrl}${tick}${Date.now()}`);
    reject(`${preSignedUrl}${tick}${Date.now()}`);
  });
}

/* To get the renewed signed url for any resource, every time it is opened on UI. */
async function getRenewedPresignedUrl(resourceOld, selectedElement, key, _this) {
  let resource = resourceOld;
  resource = resource.split(tick)[0];
  const tempResource = _.cloneDeep(resource);
  selectedElement[key] = null;
  selectedElement[key] = await renewSingleUseTokenForPresignedUrl(tempResource, _this);
  return new Promise((resolve, reject) => {
    resolve("Success");
    reject("Error");
  });
}

export { renewSingleUseTokenForPresignedUrl, getRenewedPresignedUrl };
